import React from "react";
import {
  Box,
  Stack,
  SxProps,
  Theme,
  Typography,
  useTheme,
} from "@mui/material";
import { CSS_CONSTANTS } from "../../constants/cssConstants";

import {
  Person,
  DirectionsCar,
  Description,
  Assignment,
  AttachFile,
  BusinessCenter,
  CloudUpload,
  Email,
  EditNote,
  LocalActivity,
  ReceiptLong,
  RequestQuote,
  SatelliteAlt,
  GppGood,

  // new icons
  InfoOutlined,
  FactCheck,
  MapOutlined,
  ReportProblemOutlined,
  EventNote,
  QuizOutlined,
  CampaignOutlined,
  AccountBalanceWalletOutlined,
  PolicyOutlined,
  HistoryOutlined,
  VerifiedOutlined,
  LocalParkingOutlined,
  LocationOnOutlined,
  AssignmentOutlined,
  DescriptionOutlined,
  CloudUploadOutlined,
} from "@mui/icons-material";
import { SvgIconComponent } from "@mui/icons-material";

const ICON_MAP: Record<string, SvgIconComponent> = {
  // existing
  Drivers: Person,
  Driver: Person,
  Vehicle: DirectionsCar,
  Vehicles: DirectionsCar,
  Coverage: Description,
  Applications: Assignment,
  "Garage Plates": LocalParkingOutlined,
  "Policy Forms": Description,
  Attachments: AttachFile,
  "Business Tracker": BusinessCenter,
  "Risk Location": LocationOnOutlined,
  CSIO: CloudUpload,
  eDocs: Email,
  "Email Thread": Email,
  "Policy Changes/Upload": EditNote,
  Activities: LocalActivity,
  Invoices: ReceiptLong,
  Quote: RequestQuote,
  Telematics: SatelliteAlt,
  "G4 Sign": GppGood,
  "Address History": HistoryOutlined,
  "Application": AssignmentOutlined,
  "CSIO Application": DescriptionOutlined,
  "eDocs/EDI": CloudUploadOutlined,

  // replaced ? icons with actual icons
  "Basic Details": InfoOutlined,
  Underwriting: FactCheck,
  "Risk Locations & Coverage": MapOutlined,
  Claims: ReportProblemOutlined,
  Schedules: EventNote,
  Questionnaires: QuizOutlined,
  Marketing: CampaignOutlined,
  "Premium Finance": AccountBalanceWalletOutlined,
  MPOI: PolicyOutlined,
  History: HistoryOutlined,
  "My Proof of Insurance": VerifiedOutlined,
};

const TabIcon: React.FC<{ icon: SvgIconComponent; sx: SxProps<Theme> }> = ({
  icon: Icon,
  sx,
}) => <Icon sx={sx} />;


export const PolicyTabCard: React.FC<{
  label: string;
  isSelected: boolean;
  disabled?: boolean;
  onClick: () => void;
  icon?: SvgIconComponent;
}> = ({ label, onClick, disabled, isSelected, icon: IconProp }) => {
  const theme = useTheme();
  const resolvedIcon = IconProp || ICON_MAP[label] || InfoOutlined;

  return (
    <Box
      onClick={disabled ? undefined : onClick}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: isSelected ? theme.palette.primary.main : "",
        borderRadius: CSS_CONSTANTS.BORDER_RADIUS,
        padding: "10px 18px",
        margin: "5px",
        width: "fit-content",
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? "default" : "pointer",
        "&:hover": {
          boxShadow: theme.shadows[15] + " !important",
        },
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <TabIcon
          icon={resolvedIcon}
          sx={{ color: isSelected ? "#fff" : theme.palette.grey[700] }}
        />
        <Typography
          variant="h5"
          sx={{ color: isSelected ? "#fff" : theme.palette.grey[700]}}
          textAlign="center"
          fontSize="1rem"
          fontWeight={500}
        >
          {label}
        </Typography>
      </Stack>
    </Box>
  );
};
